import axios from 'axios'
export default{
  state:{
    hijos: [],
    url_tpv_pago: '',
    url_tpv_pago_1: '',
    url_tpv_pago_2: '',
  },
  getters:{
    personas(state){
      return state.hijos
    },
    url_tpv_pago(state){
      return state.url_tpv_pago
    },
    url_tpv_pago_1(state){
      return state.url_tpv_pago_1
    },
    url_tpv_pago_2(state){
      return state.url_tpv_pago_2
    }
  },
  mutations:{  
    get_hijos(state, hijos) {
      if(typeof hijos.length !== 'undefined'){
        hijos.forEach(h => {
          state.hijos.push(h)
        })
      }
      return state.hijos
    }, 
    get_url_tpv_pago(state, url_tpv_pago) {
      state.url_tpv_pago = url_tpv_pago
      return state.url_tpv_pago
    }, 
    get_url_tpv_pago_1(state, url_tpv_pago_1) {
      state.url_tpv_pago_1 = url_tpv_pago_1
      return state.url_tpv_pago_1
    }, 
    get_url_tpv_pago_2(state, url_tpv_pago_2) {
      state.url_tpv_pago_2 = url_tpv_pago_2
      return state.url_tpv_pago_2
    }, 
    new_hijo(state, hijo) {
      state
      var hijos = []
      state.hijos.forEach(h => {
        hijos.push(h)
      })
      hijos.push(hijo)
      state.hijos = hijos
      return state.hijos
    },  
    delete_hijo(state, hijo_id) {
      state.hijos.forEach((hijo,index) => {
        if(hijo.id == hijo_id)
          state.hijos.splice(index,1)
      })
    }, 
    save_hijo(state, hijo) {
      state.hijos.forEach((hij,index) => {
        if(hij.id == hijo.id)
          state.hijos.splice(index,1,hijo)
      })
    },  
  },
  actions:{
    get_hijos(context) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
      if (context.getters['auth/loggedIn']) {
        return new Promise((resolve, reject) => {
          axios.get('/hijo')
            .then(response => {
              if(response.data.success){
                context.commit('get_url_tpv_pago',response.data.url_tpv_pago)
                context.commit('get_url_tpv_pago_1',response.data.url_tpv_pago_1)
                context.commit('get_url_tpv_pago_2',response.data.url_tpv_pago_2)
                context.commit('get_hijos',response.data.hijos)
                resolve(response.data.hijos)
              }else{
                reject(response.data.message)
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    new_hijo(context,hijo) {
      if (context.getters['auth/loggedIn']) {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
        return new Promise((resolve, reject) => {
          axios.post('/hijo',{
            nombre: hijo.nombre,
            apellidos: hijo.apellidos,
            fechaNacimiento: hijo.fechaNacimiento,
            colegio: hijo.colegio,
            telefono: hijo.telefono,
            alergias: hijo.alergias,
            abonado: hijo.abonado
          })
          .then(response => {
            if(response.data.success){
              context.commit('new_hijo',response.data.hijo)
              resolve(response.data.message)
            }else{
              reject(response.data.message)
            }
          })
          .catch(error => {
            reject(error.response)
          })
        })
      }
    },
    save_hijo(context,hijo) {
      if (context.getters['auth/loggedIn']) {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
        return new Promise((resolve, reject) => {
          axios.put('/hijo/'+hijo.menor_id,{
            nombre: hijo.nombre,
            apellidos: hijo.apellidos,
            fechaNacimiento: hijo.fechaNacimiento,
            colegio: hijo.colegio,
            telefono: hijo.telefono,
            alergias: hijo.alergias,
            abonado: hijo.abonado
          })
          .then(response => {
            if(response.data.success){
              context.commit('save_hijo',response.data.hijo)
              resolve(response.data.message)
            }else{
              reject(response.data.message)
            }
          })
          .catch(error => {
            reject(error.response)
          })
        })
      }
    },
    delete_hijo(context,hijo) {
      context.rootState.carrito.carrito.forEach((reserva_nodo,index) => {
        if(reserva_nodo.menor_id == hijo.id){
          context.commit('desaparecer',index)
        }
      })
      if (context.getters['auth/loggedIn']) {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
        return new Promise((resolve, reject) => {
          axios.delete('/hijo/'+hijo.id)
          .then(response => {
            if(response.data.success){
              context.commit('delete_hijo',hijo.id)
              resolve(response.data.message)
            }else{
              reject(response.data.message)
            }
          })
          .catch(error => {
            reject(error)
          })
        })
      }
    },
  }
}